<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'

import LineChevronLeft from '@docue/docue-ui-v2/icons/LineChevronLeft.vue'

const props = withDefaults(defineProps<{
  to?: RouteLocationRaw
  size?: 'sm' | 'lg'
}>(), {
  size: 'sm',
})

const buttonClasses = computed(() => props.size === 'lg' ? '!font-semibold' : undefined)
const iconClasses = computed(() => props.size === 'lg' ? 'h-5 w-5' : 'h-4 w-4')
</script>

<template>
  <DTButton
    variant="plain"
    :size="size"
    :to="to"
    class="group !justify-start !p-0 hover:!bg-white"
    :class="buttonClasses"
  >
    <i
      class="flex size-8 items-center justify-center rounded-full group-hover:bg-gray-100"
    >
      <LineChevronLeft
        class="text-gray-600"
        :class="iconClasses"
      />
    </i>
    <slot />
  </DTButton>
</template>
